import Vue from "vue";
import formCarValuationExistingCustomer from "./components/form-car-valuation-existing-customer.vue";
import store from "./store";
import "./assets/main.scss";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuelidate);

if (window.modalManager) {
    window.modalManager.registerFormType('car-valuation-existing-customer', {
        Vue: Vue,
        formComponent: formCarValuationExistingCustomer,
        store: store
    });
}

window.createApp_car_valuation_existing_customer = function(selector, props = {}) {
    if (!window.modalManager) {
        console.error('ModalManager not available for createApp_car_valuation_existing_customer');
        return;
    }

    if (!window.modalManager.isFormTypeRegistered('car-valuation-existing-customer')) {
        window.modalManager.registerFormType('car-valuation-existing-customer', {
            Vue: Vue,
            formComponent: formCarValuationExistingCustomer,
            store: store
        });
    }

    return window.modalManager.createFormApp('car-valuation-existing-customer', selector, props);
};
window.createApp_carValuationExistingCustomer = window.createApp_car_valuation_existing_customer;

let renderCarValuationExistingCustomerForms = function() {
    const forms = document.querySelectorAll('.form-car-valuation-existing-customer');
    if (forms.length === 0) {
        return false;
    }

    if (!window.modalManager) {
        console.error('ModalManager not available for renderCarValuationExistingCustomerForms');
        return false;
    }

    if (!window.modalManager.isFormTypeRegistered || !window.modalManager.isFormTypeRegistered('car-valuation-existing-customer')) {
        window.modalManager.registerFormType('car-valuation-existing-customer', {
            Vue: Vue,
            formComponent: formCarValuationExistingCustomer,
            store: store
        });
    }

    forms.forEach((form, index) => {
        try {
            const parentBlock = form.closest('.nitea-form-selector');
            if (parentBlock) {
                return;
            }

            if (!form.id) {
                form.id = `form-car-valuation-existing-customer-footer-${Date.now()}-${index}`;
            }

            window.modalManager.createFormApp('car-valuation-existing-customer', `#${form.id}`, {
                displayMode: 'modal'
            });
        } catch (error) {
            console.error(`Failed to initialize car-valuation-existing-customer form ${index}:`, error);
        }
    });

    return true;
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCarValuationExistingCustomerForms);
} else {
    renderCarValuationExistingCustomerForms();
}

window.renderCarValuationExistingCustomerForms = renderCarValuationExistingCustomerForms;
